/* eslint-disable no-shadow */
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Modal } from 'react-bootstrap';

import '../index.scss';
import 'bootstrap/dist/css/bootstrap.min.css';

import {
  setCurrentTemplateBotTesting,
  setCurrentTemplateBotSelected,
} from '../../../store/actions/new-bot';

const functionalitiesPlaceholder = [
  'Take Customers Request 24/7',
  'Broadcast Promotion To Potential Customer',
  'Service Listing And Management Via CMS',
  'Pick-Up And Delivery Service',
];

const tryTemplateStyle = {
  backgroundColor: '#F49400',
  color: '#ffffff',
  fontWeight: '500',
  width: 84,
  marginRight: 15,
};

const NewBotLearnMoreModal = (props) => {
  const { template, show } = props;
  const {
    title,
    categories,
    functionalities,
    shortDescription,
    longDescription,
    banner,
  } = template;

  const onHideModal = () => {
    const { setShow, setLearnMoreData } = props;
    setLearnMoreData({});
    setShow(false);
  };

  const onClickSelectTempleBot = (event) => {
    event.preventDefault();
    const { setCurrentTemplateBotSelected } = props;
    setCurrentTemplateBotSelected(template);
  };

  const onClickTryTemplateBot = (event) => {
    event.preventDefault();
    const { setCurrentTemplateBotTesting } = props;
    const { botId, title } = template;
    setCurrentTemplateBotTesting({ botId, title, isOpen: false });
  };

  const renderCategoriesTags = () => {
    if (!categories) {
      return false;
    }

    return categories.map((category, index) => {
      const key = `${category}-i-${index}`;
      return (
        <div className="template-bot-learn-more-modal-tags" key={key}>
          <span>{category}</span>
        </div>
      );
    });
  };

  const renderFunctionalities = () => {
    if (!functionalities) {
      return false;
    }
    return functionalities.map((func) => {
      return (
        <div key={func} className="func-element">
          <span>{func}</span>
        </div>
      );
    });
  };

  return (
    <div>
      <Modal
        show={show}
        onHide={onHideModal}
        enforceFocus={false}
        className="template-bot-learn-more-modal"
      >
        <Modal.Header className="template-bot-card-header" closeButton>
          <div className="banner-img">
            <img src={banner} alt="Banner" />
          </div>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>

        <Modal.Body className="template-bot-card-learn-more">
          <p>{shortDescription}</p>
          <div className="template-bot-learn-more-tags-row">
            <label>Tags:</label>
            {renderCategoriesTags()}
          </div>
          <p className="template-bot-card-learn-more-long-p">
            {longDescription}
          </p>
          <div className="template-bot-learn-more-functionalities">
            <label>Funcionalidades</label>
            <div className="template-bot-learn-more-functionalities-row">
              <div className="template-bot-learn-more-bar" />
              <div className="template-bot-learn-more-functionalities-column">
                {renderFunctionalities()}
              </div>
            </div>
          </div>
          <div className="template-bot-learn-more-actions-row">
            <button
              type="button"
              onClick={onClickTryTemplateBot}
              style={tryTemplateStyle}
            >
              Testar
            </button>
            <button type="button" onClick={onClickSelectTempleBot}>
              Usar este
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    { setCurrentTemplateBotTesting, setCurrentTemplateBotSelected },
    dispatch
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NewBotLearnMoreModal);
